import { render, staticRenderFns } from "./roomList.vue?vue&type=template&id=36bca022&scoped=true"
import script from "./roomList.vue?vue&type=script&lang=js"
export * from "./roomList.vue?vue&type=script&lang=js"
import style0 from "./roomList.vue?vue&type=style&index=0&id=36bca022&prod&lang=scss&scoped=true"
import style1 from "./roomList.vue?vue&type=style&index=1&id=36bca022&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bca022",
  null
  
)

export default component.exports